import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

/**
 * 将国家代码转换为国家名称
 * @param code 国家代码（如：'US', 'CN'）
 * @param locale 语言代码（'en' 或 'zh'）
 * @returns 国家名称
 */
export const getCountryName = (code: string, locale: 'en' | 'zh' = 'en'): string => {
    try {
        return countries.getName(code, locale, {select: 'alias'}) || code;
    } catch (error) {
        console.error('Invalid country code:', code);
        return code;
    }
};

/**
 * 获取所有国家列表
 * @param locale 语言代码（'en' 或 'zh'）
 * @returns 国家代码和名称的映射对象
 */
export const getCountries = (locale: 'en' | 'zh' = 'en'): Record<string, string> => {
    return countries.getNames(locale);
}; 